import fastdom from 'fastdom'
import _ from 'lodash'

export const name = 'WindowScrollAsCssVariableAspect'

// ImageX component uses cssVars for scrollEffect calculation.
// Values for some of these vars are set here
const SCROLL_EFFECT_CSS_CLASS = 'scroll-css-var--scrollEffect'
const SCROLL_CSS_VAR = '--scroll'

const getElementsWithScrollEffect = windowObject => windowObject.document.getElementsByClassName(SCROLL_EFFECT_CSS_CLASS)

export const functionLibrary = {
    writeScrollPosition: (windowObject, componentViewMode, scrollY) => {
        if (!windowObject || componentViewMode === 'editor') {
            return
        }

        fastdom.mutate(() => {
            // set cssVar as inline style, it is more efficient than to create <style>.scroll-css-var--scrollEffect {...}</style>
            const elementsWithScrollEffect = getElementsWithScrollEffect(windowObject)
            _.forEach(elementsWithScrollEffect, element => element.style.setProperty(SCROLL_CSS_VAR, scrollY))
        })
    }
}
